module.exports = __webpack_public_path__ + "img/fichee.1b8978f8.svg";